var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('h5-header'):_c('pc-header')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }